import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface ActivityContextType {
  openActivityId: string | null;
  openActivity: (activityId: string) => void;
  closeActivity: () => void;
}

const ActivityContext = createContext<ActivityContextType | undefined>(undefined);

export function ActivityProvider({ children }: { children: ReactNode }) {
  const [openActivityId, setOpenActivityId] = useState<string | null>(null);

  const openActivity = useCallback((activityId: string) => {
    setOpenActivityId(activityId);
  }, []);

  const closeActivity = useCallback(() => {
    setOpenActivityId(null);
  }, []);

  return (
    <ActivityContext.Provider value={{ openActivityId, openActivity, closeActivity }}>
      {children}
    </ActivityContext.Provider>
  );
}

export function useActivityContext() {
  const context = useContext(ActivityContext);
  if (!context) {
    throw new Error('useActivityContext must be used within ActivityProvider');
  }
  return context;
}
